//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    props: {
        data: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            columns: [
                {
                    name: 'name',
                    required: true,
                    label: 'Nombre',
                    align: 'left',
                    field: 'name',
                    sortable: true,
                },
                {
                    name: 'email',
                    align: 'left',
                    label: 'Correo',
                    field: 'email',
                    sortable: true,
                },
                {
                    name: 'phone',
                    align: 'left',
                    label: 'Numero',
                    field: 'phone',
                    sortable: true,
                },
                {
                    name: 'type',
                    align: 'left',
                    label: 'Tipo',
                    field: 'type',
                    sortable: true,
                },
                {
                    name: 'plan',
                    align: 'left',
                    label: 'Plan',
                    field: 'plan',
                    sortable: true,
                },
                {
                    name: 'url',
                    align: 'left',
                    label: 'URL',
                    field: 'path',
                    sortable: true,
                },
                {
                    name: 'actions',
                    align: 'left',
                    label: 'Acciones',
                },
            ],
        }
    },
    methods: {
        toggleActive(id, active) {
            this.$emit('activeToggle', {id, active: !active})
        },
        editRestaurant(id) {
            this.$emit('editRestaurant', {id})
        },
    },
}
